import { action } from 'satcheljs/lib/legacy';
import { FeedbackViewState } from '../store/schema/FeedbackViewState';

export default action('setRatingState')(function setRatingState(
    state: FeedbackViewState,
    rating: number
) {
    // If the user click on the star when it is already on, then unstar it.
    state.rating = state.rating == rating ? 0 : rating;
});
